import * as React from 'react';
import { Helmet } from 'react-helmet';

interface SEOStructuredDataProps {
  author: string;
  date: string;
  image?: string;
  synopsis: string;
  title: string;
}

export const SEOStructuredData: React.ComponentType<SEOStructuredDataProps> =
  React.memo(({ image = '', author, date, title, synopsis }) => {
    return (
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BlogPost',
            headline: title,
            description: synopsis,
            image: image,
            author: {
              '@type': 'Person',
              name: author
            },
            datePublished: date
          })}
        </script>
      </Helmet>
    );
  });
